<template>
<div class="setup-section">
  <div class="setup">
    <h3>Настройки</h3>
    <div class="setup__list">

      <p class="setup__item">
        <span>Режим:</span>
        <v-select 
          label="text" 
          :clearable="false"
          :options="[
            {id: 'digits', text: 'Цифры'},
            {id: 'letters', text: 'Буквы'}
          ]" 
          v-model="params.mode"
          :reduce="option => option.id" 
          @input="checkMode"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select> 
      </p>

      <p class="setup__item">
        <span>Поле:</span>
        <v-select 
          :options="sizes" 
          v-model="params.size" 
          :clearable="false"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.label + 'x' + option.label }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.label + 'x' + option.label }}
            </div>
          </template>
        </v-select> 
      </p>

      <div class="setup__item setup__item--radio">
        <span>Счёт: </span>

        <div>
          <input type="radio" id="direct" value="direct" v-model="params.direction">
          <label for="direct">Прямой</label>

          <input type="radio" id="reverse" value="reverse" v-model="params.direction">
          <label for="reverse">Обратный</label>

          <input type="radio" id="random" value="random" v-model="params.direction">
          <label for="random">Случайный</label>
        </div>
        
      </div>

      <p class="setup__item">
        <span>Угол поворота: ({{ params.rotate }})</span>
        <range-slider
          class="setup__range"
          @change="$emit('params_changed', params)"
          min="0"
          max="180"
          step="1"
          v-model="params.rotate">
        </range-slider>
      </p>

      <div v-show="!autoSettings">
        <p class="setup__item setup__item--checkbox">
          <input type="checkbox" id="shuffle" v-model="params.shuffle">
          <label for="shuffle">Перемешивать при клике</label>
        </p>
        <p class="setup__item setup__item--checkbox">
          <input type="checkbox" id="show-reactions" v-model="params.reactions">
          <label for="show-reactions">Анимация</label>
        </p>
      </div>
    </div>
    <button 
      class="uk-button uk-button-primary setup__button" 
      @click="$emit('start', params)"
      v-if="!is_homework"
    >
      СТАРТ!
    </button>
  </div>
  <div class="setup__description" v-if="!is_homework">
    <h3>Инструкция</h3>
    <div class="setup__text" v-html="trainer.instruction"></div>
    <div class="setup__image">
      <img v-if="trainer.inner_image" :src="trainer.inner_image.path" alt="">
    </div>
  </div>
</div>
</template>

<script>
import RangeSlider from 'vue-range-slider'
import vSelect from 'vue-select'

export default {
  props: ['trainer', 'is_homework', 'homework_params', 'autoSettings'],
  components: { RangeSlider, vSelect },
  data() {
    return {
      params: {
        mode: 'digits',
        size: 3,
        rotate: 0,
        direction: 'direct',
        reactions: false,
        shuffle: false
      }
    }
  },
  computed: {
    sizes() {
      let arr = [3, 4, 5, 6, 7, 8]

      if (this.params.mode === 'letters') {
        arr = arr.slice(0, 3)
      }

      return arr
    }
  },
  methods: {
    checkMode() {
      console.log(this.params.mode)
      if (this.params.mode === 'letters') {
        this.params.size = 3
      }
    }
  },
  created() {
    if (this.homework_params) {
      this.params = this.homework_params
    }
  },
  mounted() {    
    this.$emit('params_changed', this.params)
  },
  watch: {
    params: {
      handler: function (params) { 
        this.$emit('params_changed', params)
      },
      deep: true
    }
  }
}
</script>

